// Public token URLs contain bearer credentials. Remove them from telemetry, including
// navigation breadcrumbs and API spans that may be sent on a later page.
export function redactReviewToken<T>(value: T): T {
  if (typeof value === "string") {
    return value
      .replace(
        /((?:\/|%2f)(?:a|%61)(?:p|%70)(?:p|%70)(?:o|%6f)(?:i|%69)(?:n|%6e)(?:t|%74)(?:m|%6d)(?:e|%65)(?:n|%6e)(?:t|%74)(?:s|%73)(?:\/|%2f))[^/?#%&\s"']+/gi,
        "$1[redacted]"
      )
      .replace(
        /(\/appointments\/|\/booking\/review\/|\/booking\/p\/|\/beautyflow\/public\/reviews\/|\/beautyflow\/public\/personal-booking\/)[^/?#\s"']+/g,
        "$1[redacted]"
      )
      .replace(
        /([?&](?:personalBookingToken|appointmentToken|token|payment_intent_client_secret|client_secret)=)[^&#\s"']+/gi,
        "$1[redacted]"
      )
      .replace(
        /("(?:personalBookingToken|appointmentToken|token|payment_intent_client_secret|client_secret)"\s*:\s*")[^"]*(")/g,
        "$1[redacted]$2"
      ) as T;
  }
  if (Array.isArray(value)) return value.map(redactReviewToken) as T;
  if (value && typeof value === "object" && Object.getPrototypeOf(value) === Object.prototype) {
    return Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [
        key,
        [
          "personalBookingToken",
          "appointmentToken",
          "token",
          "payment_intent_client_secret",
          "client_secret",
        ].includes(key)
          ? "[redacted]"
          : redactReviewToken(entry),
      ])
    ) as T;
  }
  return value;
}
